import { Component, Input, ViewChild } from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { DataType } from '../../models/data-type.model';
import { Tag } from '../../models/tag.model';
import { PatientDatum, ImageDatum } from '../../models/data-group.model';
import { SearchFilters } from '../../models/search-filters.model';
declare var jQuery: any;

@Component({
  selector: 'lowy-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent {
  // collection of all filters
  public filters: SearchFilters;

  @Input() allowEdit: boolean;

  public isOverflown = false;
  public overflowCount: number;
  public isCollapsed = true;
  public isOpen: boolean;

  public setFilters(filters: SearchFilters) {
    this.filters = filters;

    jQuery(document).ready($ => {
      const parentContainerWidth = $('.tag-list').width();
      const overflowCount = $('mat-chip').filter(function() {
        return $(this).offset().left >= parentContainerWidth;
      }).length;

      if (overflowCount > 0) {
        this.isOverflown = true;
        this.overflowCount = overflowCount;
        // show more icon and do fading icon
      }
      else {
        this.isOverflown = false;
      }
    });
  }

  public expandTagList() {
    this.isCollapsed = false;
    setTimeout(() => {
      this.isOpen = true;
    });
  }

  public collapseTagList() {
    this.isOpen = false;
    setTimeout(() => {
      this.isCollapsed = true;
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tag-list/tag-list.component.ts